// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__fBayP","title":"styles_title__hbKOo"};